import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import './FlipCard.scss';
import { FlipCardProps } from './types';

export const FlipCard: React.FunctionComponent<FlipCardProps> = (props) => {
    const { showBack, cardFront, cardBack } = props;
    const flipCardClassNames = classNames('flip-card', {
        'flip-card--animate': showBack,
    });
    const cardFrontRef = useRef<any>(null);

    // fixes a focus bug where the card keeps focus after mouseout of a flipped card
    const [showFront, setShowFront] = useState(true);
    useEffect(() => {
        if (showBack) {
            setTimeout(() => {
                setShowFront(false);
                setShowFront(true);
            }, 300);
        }
    }, [showBack]);

    return (
        <>
            <div className={flipCardClassNames}>
                <div className="flip-card__inner">
                    {showFront ? (
                        <div className="flip-card__front" ref={cardFrontRef}>
                            {cardFront}
                        </div>
                    ) : null}
                    <div className="flip-card__back">{cardBack}</div>
                </div>
            </div>
            {/* Re-rendering the front card in a hidden container to get the height for cards on mobile */}
            <div className="flip-card__front--hidden" ref={cardFrontRef}>
                {cardFront}
            </div>
        </>
    );
};
